<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            {{ form.id ? "Update Fee" : "Create New Fee" }}
          </h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Route</label>
                <ValidationProvider name="route" rules="required" v-slot="{ passed, failed }">
                  <el-select v-model="form.route_id" placeholder="Select" filterable class="form-group" :class="[
                      { 'has-danger': failed },
                      { 'has-success': passed }]">
                    <el-option :value="route.id" :label="route.code" v-for="route in routes" :key="route.id">{{ route.code }}</el-option>
                  </el-select><br>
                  <span class="error-text" v-if="failed">Route is required</span>
                </ValidationProvider>
              </div>
            </div>
         
            <div class="col-md-6">
              <div class="form-group">
                <label>Service Fee (%)</label>
                <el-input v-model="form.service_fee" type="number"></el-input>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Additional Charge (Fixed Amount)</label>
                <el-input v-model="form.additional_charge" type="number"></el-input>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Passenger Type</label>
                <ValidationProvider name="passenger_type" rules="required" v-slot="{ passed, failed }">
                  <el-select v-model="form.passenger_types" placeholder="Select" filterable :multiple="true"
                    class="form-group bold-text-blue super-bold" :class="[
    { 'has-danger': failed },
    { 'has-success': passed }]">
                    <el-option :value="p" :label="p" v-for="p, i in $store.state.passenger_types" :key="i">{{ p
                      }}</el-option>
                  </el-select><br>
                  <span class="error-text" v-if="failed">Passenger type is required</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
              <label>Start Date</label>
              <ValidationProvider name="start_date" rules="required" v-slot="{ passed, failed }">
                <el-date-picker v-model="form.start_date" type="date" placeholder="Pick a day" class="form-group" :class="[
                      { 'has-danger': failed },
                      { 'has-success': passed }]">
                </el-date-picker>
                <br><span class="error-text" v-if="failed">Start date is required</span>
              </ValidationProvider>
            </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-right">
          <p-button type="info" native-type="submit">Save</p-button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { OnlineBookingFee } from "@/resources/online_booking_fee";
import { Route } from "@/resources/route";

extend("required", required);

export default {
  props: ["online_booking_fee"],
  data() {
    return {
      form: {
        code: "",
        name: "",
      },
      routes: []
    };
  },
  watch: {
    online_booking_fee: function () {
      if (this.online_booking_fee)
        this.form = Object.assign({}, this.online_booking_fee);
    },
  },
  created: function () {
    if (this.online_booking_fee) this.form = Object.assign({}, this.online_booking_fee);
    this.getRoutes()
  },
  beforeDestroy() {
    this.form = {
      route_id: "",
    };
  },
  methods: {
    getRoutes() {
      this.$loading = true;
      Route.get({
        per_page: 999,
      })
        .then((result) => {
          this.routes = result.data.routes;
        })
        .catch(() => {})
        .finally(() => {
          this.$loading = false;
        });
    },
    submit() {
      this.$loading = true;

      let request = this.form.id
        ? OnlineBookingFee.update(this.form)
        : OnlineBookingFee.create(this.form);

      request
        .then((result) => {
          this.$notify({
            type: "success",
            title: "Success",
            text: "Fee has been saved",
          });
          this.$emit("save", true);
        })
        .catch((error) => {
          let message =
            error.response.data.message || "Unable to save this time";
          this.$notify({
            type: "danger",
            title: "Error",
            text: message,
          });
        })
        .finally(() => {
          this.$loading = false;
        });
    },
  },
};
</script>

<style></style>
